(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 13096:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(93609);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ UtilityPagesApi; }
/* harmony export */ });
/* harmony import */ var _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74552);

class UtilityPagesApi {
    getUtilityPage(slug) {
        return this.client.get("/api/utils-pages/slugs/".concat(slug), {}, false);
    }
    constructor(client = new _parkschannel_next_utils__WEBPACK_IMPORTED_MODULE_0__/* .HttpClient */ .e()){
        this.client = client;
    }
}


/***/ }),

/***/ 20416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ CTAList; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/icons/ArrowRight/ArrowRight.tsx
var ArrowRight = __webpack_require__(71740);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui/src/components/CTA/CTACard/CTACard.tsx





const CTACard = (param)=>{
    let { data , renderImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "min-w-[293px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-[244px] w-full rounded-2xl overflow-hidden mb-6",
                children: renderImage ? renderImage(data) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                    src: data.img,
                    className: "object-cover",
                    alt: data.title,
                    fill: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "h4",
                        className: "mb-1 text-neutral-900 lg:mb-2",
                        children: data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "bodyXL",
                        className: "text-neutral-600 mb-4",
                        children: data.text
                    }),
                    isCTAWithButton(data) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        disabled: data.disabled,
                        className: classnames_default()("flex items-center gap-1 text-sm font-semibold", {
                            "text-neutral-600": !data.disabled,
                            "text-neutral-200": data.disabled
                        }),
                        onClick: data.onClick,
                        children: [
                            data.buttonText,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                className: classnames_default()("w-6 h-6", {
                                    "text-primary-500": !data.disabled,
                                    "text-primary-100": data.disabled
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: data.disabled ? "#" : data.linkHref,
                        className: classnames_default()("flex items-center gap-1text-sm font-semibold", {
                            "text-neutral-600": !data.disabled,
                            "text-neutral-200": data.disabled
                        }),
                        children: [
                            data.linkText,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                className: classnames_default()("w-6 h-6", {
                                    "text-primary-500": !data.disabled,
                                    "text-primary-100": data.disabled
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function isCTAWithButton(data) {
    return data.onClick !== undefined;
}

;// CONCATENATED MODULE: ./modules/CallToAction/CTAList/CTAList.tsx



const CTAList = (param)=>{
    let { data , renderImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "w-full flex overflow-x-auto gap-[20px] pb-4 md:gap-8 lg:gap-12",
        items: data,
        renderItem: (cta)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CTACard, {
                data: cta,
                renderImage: renderImage
            })
    });
};


/***/ }),

/***/ 29261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ CTASection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59785);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86978);
/* harmony import */ var _CTAList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20416);
/* harmony import */ var _Auth_AuthContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35836);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19266);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_2__);






const CTA_DATA = [
    {
        id: 1,
        title: "Watch and create",
        text: "We curate videos that entertain and inform. Join our growing community of creators – or simply explore.",
        linkText: "Explore videos",
        linkHref: "/explore-parks",
        img: "/media/illustrations/watch-and-create.webp"
    },
    {
        id: 2,
        title: "Plan",
        text: "Our curated checklists will help make sure you have everything you need.",
        linkText: "Start planning",
        linkHref: "/trip-planner",
        img: "/media/illustrations/plan.webp"
    }
];
const WITHOUT_SESSION_CARD = {
    id: 3,
    title: "Go",
    text: "Create your own profile, playlists and checklists.",
    onClick: ()=>(0,next_auth_react__WEBPACK_IMPORTED_MODULE_2__.signIn)("cognito"),
    buttonText: "Create an account",
    img: "/media/illustrations/join.webp"
};
const WITH_SESSION_CARD = {
    id: 4,
    title: "Go",
    text: "Create your own profile, playlists and checklists.",
    linkText: "Create an account",
    linkHref: "/users/me/",
    img: "/media/illustrations/join.webp"
};
const CTASection = ()=>{
    const { useSession  } = (0,_Auth_AuthContext__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const session = useSession();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full pl-4 py-10 max-w-screen-2xl mx-auto md:py-[56px] md:pl-[30px] lg:px-10 lg:py-[80px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full max-w-6xl mx-auto",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .Z, {
                        variant: "h2",
                        className: "pr-4 text-neutral-900 mb-6 md:pr-[30px] lg:pr-0 lg:mb-[56px]",
                        children: "Parks Channel - the first stop for your next adventure!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CTAList__WEBPACK_IMPORTED_MODULE_5__/* .CTAList */ .t, {
                        data: [
                            ...CTA_DATA,
                            session && session.data ? WITH_SESSION_CARD : WITHOUT_SESSION_CARD
                        ],
                        renderImage: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__/* .SimpleImage */ .E, {
                                src: data.img,
                                className: "object-contain object-left",
                                alt: data.title,
                                fill: true
                            })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ OurPartnersSection; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Carousel/Carousel.tsx
var Carousel = __webpack_require__(7346);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./modules/ImgixImage/index.tsx
var ImgixImage = __webpack_require__(86645);
;// CONCATENATED MODULE: ./modules/Partners/OurPartnersSection/OurPartnersCarousel.tsx





const responsive = {
    0: {
        items: 2
    },
    568: {
        items: 3
    },
    768: {
        items: 4
    },
    1280: {
        items: 6
    },
    1536: {
        items: 7
    },
    1800: {
        items: 8
    },
    1920: {
        items: 10
    }
};
const OurPartnersCarousel = (param)=>{
    let { carouselRef , itemBackground , data  } = param;
    const slides = (0,react.useMemo)(()=>data.map((slide)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(OurPartnersCarouselItem, {
                data: slide,
                itemBackground: itemBackground
            }, slide.id)), [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        disableDotsControls: true,
        responsive: responsive,
        paddingRight: 50,
        ref: carouselRef,
        items: slides
    });
};
function OurPartnersCarouselItem(param) {
    let { data , itemBackground ="white"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("w-[120px] h-[120px] bg-white rounded-full flex items-center p-4 justify-center overflow-hidden lg:p-6 lg:w-[200px] lg:h-[200px] ", renderItemBackground(itemBackground)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: data.link,
            target: "_blank",
            className: "w-full h-full relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgixImage/* ImgixImage */.T, {
                src: data.avatar_key || "",
                fill: true,
                className: "object-contain",
                alt: "".concat(data.name, " logo")
            })
        })
    });
}
function renderItemBackground(bgc) {
    switch(bgc){
        case "gray":
            return "bg-neutral-50";
        default:
            return "bg-white";
    }
}

// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/ChevronLeft/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(7595);
// EXTERNAL MODULE: ../ui/src/icons/ChevronRight/ChevronRight.tsx
var ChevronRight = __webpack_require__(98427);
// EXTERNAL MODULE: ./modules/Api/UtilitiesPages/index.ts
var UtilitiesPages = __webpack_require__(27163);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
;// CONCATENATED MODULE: ./modules/Partners/hooks.ts


const useOurPartners = ()=>{
    const utilityPages = new UtilitiesPages/* UtilityPagesApi */.d();
    const useOurPartnersQuery = function() {
        let slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "our-partners";
        return (0,index_production.useQuery)([
            "utility-pages",
            slug
        ], ()=>utilityPages.getUtilityPage(slug), {
            refetchOnWindowFocus: false,
            retry: false
        });
    };
    return {
        useOurPartnersQuery
    };
};

;// CONCATENATED MODULE: ./modules/Partners/types.ts
class OurPartner {
    static fromOurPartnersResponse(data) {
        var ref;
        return new OurPartner((ref = data.avatarKey) === null || ref === void 0 ? void 0 : ref.key, data.id, data.name, data.link);
    }
    toJSON() {
        return {
            avatar_key: this.avatar_key,
            id: this.id,
            name: this.name,
            link: this.link,
            avatar_url: this.avatar_key
        };
    }
    get avatar_url() {
        if (!this.avatar_key) return this.avatar_key;
        return "/api/utils-pages/images?imageKey=".concat(this.avatar_key);
    }
    constructor(avatar_key, id, name, link){
        this.avatar_key = avatar_key;
        this.id = id;
        this.name = name;
        this.link = link;
    }
}

;// CONCATENATED MODULE: ./modules/Partners/OurPartnersSection/OurPartnersSection.tsx






const OurPartnersSection = (param)=>{
    let { itemBackground  } = param;
    const carouselRef = (0,react.useRef)(null);
    const { useOurPartnersQuery  } = useOurPartners();
    const { data: ourPartners  } = useOurPartnersQuery();
    const partners = (0,react.useMemo)(()=>{
        var ref;
        return ((ourPartners === null || ourPartners === void 0 ? void 0 : (ref = ourPartners.data) === null || ref === void 0 ? void 0 : ref.partners) || []).map((member)=>OurPartner.fromOurPartnersResponse(member));
    }, [
        ourPartners
    ]);
    const slideNext = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slideNext(null);
    };
    const slidePrev = ()=>{
        if (!carouselRef.current) return;
        carouselRef.current.slidePrev(null);
    };
    if (partners.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "w-full overflow-x-hidden pt-6 pb-[72px] lg:pt-[56px] lg:pb-[100px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 md:px-[30px] lg:px-[40px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center mb-6 lg:mb-[60px] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                component: "h2",
                                variant: "h3",
                                className: "text-neutral-900",
                                children: "Our partners"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden lg:flex lg:gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                                        size: "sm",
                                        variant: "base",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* ChevronLeft */.s, {}),
                                        onClick: slidePrev
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                                        size: "sm",
                                        variant: "base",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* ChevronRight */._, {}),
                                        onClick: slideNext
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurPartnersCarousel, {
                carouselRef: carouselRef,
                itemBackground: itemBackground,
                data: partners
            })
        ]
    });
};


/***/ }),

/***/ 81806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ TvStatus; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const TvStatus = (param)=>{
    let { icon , color ="white" , text , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("px-4 py-2 rounded-full flex items-center gap-2 text-xs font-medium w-fit", tvStatusBgColor(color), tvStatusTextColor(color), className),
        children: [
            icon ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-[8px] h-[8px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute w-full h-full rounded-full bg-white p-[2px] border border-2 border-red-600 drop-shadow-[0_0_4px_#DC2626] animate-ping opacity-40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-red-600 w-2 h-2 rounded-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: text || "On now"
            })
        ]
    });
};
function tvStatusBgColor(color) {
    switch(color){
        case "red":
            return "bg-red-600";
        default:
            return "bg-white";
    }
}
function tvStatusTextColor(color) {
    switch(color){
        case "red":
            return "text-white";
        default:
            return "text-black";
    }
}


/***/ }),

/***/ 93609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ./modules/Tv/TvStatus/TvStatus.tsx
var TvStatus = __webpack_require__(81806);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/AboutUsCover/AboutUsCover.tsx




const AboutUsCover = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative bg-neutral-200 w-full h-[568px] rounded-2xl overflow-hidden lg:h-[635px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-0 left-0 w-full h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                        src: "/media/flower-photography.jpg",
                        fill: true,
                        className: "object-cover",
                        alt: "About us page cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/20 to-black/50"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pt-8 pb-10 w-full h-full relative bg-transparent flex flex-col justify-between md:px-[30px] md:py-10 lg:px-[116px] lg:pt-[80px] lg:pb-[100px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                component: "h5",
                                variant: "h6",
                                className: "uppercase text-white mb-4",
                                children: "the parks channel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TvStatus/* TvStatus */.l, {
                                text: "About us",
                                color: "white",
                                className: "gap-1 !py-1 !px-3",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/TPC-small-logo.png",
                                    alt: "The Parks Channel logo"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: "max-w-[521px] lg:max-w-[775px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                variant: "h1",
                                className: "line-clamp-3 !text-[28px] text-white mb-2 lg:!text-[48px] lg:mb-3",
                                children: "We are the Parks Channel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                variant: "bodyXL",
                                className: "line-clamp-3 text-white",
                                children: "We believe in the power of places to inspire, entertain and inform"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/CallToAction/CTASection/CTASection.tsx
var CTASection = __webpack_require__(29261);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/DescriptionSection/DescriptionSection.tsx




const DescriptionSection = (param)=>{
    let { reverse , icon , bgcImg , children , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()("flex flex-col gap-8 md:gap-5 md:items-center lg:justify-between", {
            "md:flex-row-reverse": reverse,
            "md:flex-row": !reverse
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full lg:max-w-[425px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 lg:mb-6",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "h2",
                        className: "text-neutral-800 mb-4 md:mb-2 lg:mb-4",
                        children: title
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-[313px] overflow-hidden rounded-2xl lg:max-w-[542px] lg:h-[489px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                    src: bgcImg,
                    alt: "".concat(title, " background"),
                    fill: true,
                    className: "object-cover"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/DescriptionSection/DescriptionSectionParagraph.tsx




const DescriptionSectionParagraph = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
        variant: "bodyXL",
        className: classnames_default()("text-neutral-600 mb-2", className),
        children: children
    });
};

// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ../ui/src/components/Avatar/CardAvatar.tsx
var CardAvatar = __webpack_require__(36221);
// EXTERNAL MODULE: ../ui/src/components/Avatar/Avatar.tsx
var Avatar = __webpack_require__(18434);
// EXTERNAL MODULE: ../ui/src/components/Tag/Tag.tsx
var Tag = __webpack_require__(90202);
;// CONCATENATED MODULE: ../ui/src/components/TeamCard/TeamCard.tsx




const TeamCard = (param)=>{
    let { src , name , position , text , avatar  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "w-full h-full bg-white drop-shadow p-4 rounded-2xl grid grid-cols-[min-content_1fr] gap-4 items-center md:gap-x-8 md:gap-y-3 md:p-6 md:items-start md:grid-rows-[min-content_1fr]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:row-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAvatar/* CardAvatar */.V, {
                    size: "xl",
                    backgroundClassName: "md:p-3 lg:p-4",
                    children: avatar || /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                        src: src,
                        size: "xl",
                        className: classnames_default()("md:w-[136px] md:h-[136px] lg:w-[168px] lg:h-[168px] drop-shadow-xl")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "h4",
                        component: "h3",
                        className: "!text-lg mb-2 text-neutral-900",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                        value: position,
                        size: "sm",
                        color: "yellow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "col-span-2 text-xs leading-[18px] text-neutral-600 md:col-start-2 md:col-end-2 md:col-auto ",
                children: text
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/NextAvatar/index.tsx
var NextAvatar = __webpack_require__(77420);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/TeamCardList/TeamCardList.tsx





const TeamCardList = (param)=>{
    let { members  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10 ",
        items: members,
        renderItem: (member)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TeamCard, {
                name: member.name,
                position: member.shortDescription,
                text: member.description,
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextAvatar/* NextAvatar */.t, {
                    src: member.avatar_key,
                    size: "xl",
                    className: classnames_default()("md:w-[136px] md:h-[136px] lg:w-[168px] lg:h-[168px] drop-shadow-xl")
                })
            })
    });
};

;// CONCATENATED MODULE: ../ui/src/components/TeamCard/TeamTile.tsx



const TeamTile = (param)=>{
    let { src , position , name , avatar , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        onClick: onClick,
        className: "w-full h-full bg-white drop-shadow p-4 rounded-2xl grid grid-cols-[min-content_1fr] items-center gap-4 cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAvatar/* CardAvatar */.V, {
                size: "xl",
                children: avatar || /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                    src: src,
                    size: "xl",
                    className: "drop-shadow-xl"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        component: "h4",
                        variant: "h6",
                        className: "mb-1 text-neutral-900",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs leading-[18px] text-neutral-500",
                        children: position
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/AdvisorModal/AdvisorModalContext.tsx


const AdvisorModalContext = /*#__PURE__*/ react.createContext({
    advisor: null,
    setAdvisor: ()=>null
});
const useAdvisorModal = ()=>react.useContext(AdvisorModalContext);
const AdvisorModalProvider = (param)=>{
    let { children  } = param;
    const [selectedAdvisor, setSelectedAdvisor] = (0,react.useState)(null);
    const handleSetAdvisor = (0,react.useCallback)((advisor)=>{
        setSelectedAdvisor(advisor);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvisorModalContext.Provider, {
        value: {
            advisor: selectedAdvisor,
            setAdvisor: handleSetAdvisor
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/TeamTileList/TeamTileList.tsx





const TeamTileList = (param)=>{
    let { members  } = param;
    const { setAdvisor  } = useAdvisorModal();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-y-6 md:gap-x-[20px] lg:grid-cols-3 lg:gap-y-8 lg:gap-x-10",
        items: members,
        renderItem: (member)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TeamTile, {
                onClick: ()=>setAdvisor(member),
                name: member.name,
                position: member.shortDescription,
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextAvatar/* NextAvatar */.t, {
                    src: member.avatar_key,
                    size: "xl",
                    className: "drop-shadow-xl"
                })
            })
    });
};

// EXTERNAL MODULE: ./modules/Api/UtilitiesPages/index.ts
var UtilitiesPages = __webpack_require__(27163);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/hooks.ts


const useAboutUsPage = ()=>{
    const utilityPages = new UtilitiesPages/* UtilityPagesApi */.d();
    const useAboutUsPageQuery = function() {
        let slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "about-us";
        return (0,index_production.useQuery)([
            "utility-pages",
            slug
        ], ()=>utilityPages.getUtilityPage(slug));
    };
    return {
        useAboutUsPageQuery
    };
};

;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/types.ts
class AboutUsAdvisor {
    static fromAboutUsResponse(data) {
        var ref;
        return new AboutUsAdvisor((ref = data.avatarKey) === null || ref === void 0 ? void 0 : ref.key, data.id, data.name, data.description, data.shortDescription);
    }
    toJSON() {
        return {
            avatar_key: this.avatar_key,
            id: this.id,
            name: this.name,
            shortDescription: this.shortDescription,
            avatar_url: this.avatar_url,
            description: this.description
        };
    }
    get avatar_url() {
        if (!this.avatar_key) return this.avatar_key;
        return "/api/utils-pages/images?imageKey=".concat(this.avatar_key);
    }
    constructor(avatar_key, id, name, description, shortDescription){
        this.avatar_key = avatar_key;
        this.id = id;
        this.name = name;
        this.description = description;
        this.shortDescription = shortDescription;
    }
}
class AboutUsTeamMember {
    static fromAboutUsResponse(data) {
        var ref;
        return new AboutUsTeamMember((ref = data.avatarKey) === null || ref === void 0 ? void 0 : ref.key, data.id, data.name, data.shortDescription, data.description);
    }
    toJSON() {
        return {
            avatar_key: this.avatar_key,
            id: this.id,
            name: this.name,
            shortDescription: this.shortDescription,
            description: this.description,
            avatar_url: this.avatar_url
        };
    }
    get avatar_url() {
        if (!this.avatar_key) return this.avatar_key;
        return "/api/utils-pages/images?imageKey=".concat(this.avatar_key);
    }
    constructor(avatar_key, id, name, shortDescription, description){
        this.avatar_key = avatar_key;
        this.id = id;
        this.name = name;
        this.shortDescription = shortDescription;
        this.description = description;
    }
}

// EXTERNAL MODULE: ../ui/src/components/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(88044);
// EXTERNAL MODULE: ./modules/ImgixImage/index.tsx
var ImgixImage = __webpack_require__(86645);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/AdvisorModal/AdvisorModal.tsx






const AdvisorModal = ()=>{
    const { advisor , setAdvisor  } = useAdvisorModal();
    if (!advisor) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        isOpen: !!advisor,
        setIsOpen: ()=>setAdvisor(null),
        contentClassName: classnames_default()("h-screen max-w-[700px] md:h-auto overflow-y-auto"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full mt-10 pb-6 md:pl-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[250px] w-full relative rounded-xl mb-4 md:w-[250px] md:float-left md:mr-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgixImage/* ImgixImage */.T, {
                        src: advisor.avatar_key,
                        alt: advisor.name,
                        fill: true,
                        className: "object-cover md:object-contain"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "h4",
                            component: "h3",
                            className: "text-neutral-900",
                            children: advisor.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "bodyBase",
                            className: "text-neutral-700",
                            children: advisor.shortDescription
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    variant: "bodyLarge",
                    className: "whitespace-pre-wrap text-neutral-700",
                    children: advisor.description
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/WhoWeAreSection/WhoWeAreSection.tsx








const WhoWeAreSection = ()=>{
    const { useAboutUsPageQuery  } = useAboutUsPage();
    const { data: aboutUs  } = useAboutUsPageQuery();
    const members = (0,react.useMemo)(()=>{
        var ref;
        return ((aboutUs === null || aboutUs === void 0 ? void 0 : (ref = aboutUs.data) === null || ref === void 0 ? void 0 : ref.team) || []).map((member)=>AboutUsTeamMember.fromAboutUsResponse(member));
    }, [
        aboutUs
    ]);
    const advisors = (0,react.useMemo)(()=>{
        var ref;
        return ((aboutUs === null || aboutUs === void 0 ? void 0 : (ref = aboutUs.data) === null || ref === void 0 ? void 0 : ref.advisors) || []).map((advisor)=>AboutUsAdvisor.fromAboutUsResponse(advisor));
    }, [
        aboutUs
    ]);
    if (!aboutUs) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                variant: "h2",
                className: "text-neutral-800 mb-6 lg:mb-8",
                children: "Who we are"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamCardList, {
                members: members
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-10 lg:pt-[56px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        component: "h3",
                        variant: "h4",
                        className: "text-neutral-900 mb-6 lg:mb-8",
                        children: "Board of Advisors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvisorModalProvider, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamTileList, {
                                members: advisors
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvisorModal, {})
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../ui/src/components/Banners/BannerWrapper.tsx
var BannerWrapper = __webpack_require__(74718);
// EXTERNAL MODULE: ../ui/src/components/IconButton/IconButton.tsx
var IconButton = __webpack_require__(38937);
// EXTERNAL MODULE: ../ui/src/icons/ArrowRight/ArrowRight.tsx
var ArrowRight = __webpack_require__(71740);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/JoinGroupBanner/JoinGroupBanner.tsx




const JoinGroupBanner = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerWrapper/* BannerWrapper */.S, {
        className: "bg-neutral-100",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative w-full h-[200px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                src: "/media/illustrations/selfie.webp",
                alt: "Grand canyon",
                fill: true,
                className: "object-contain"
            })
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                component: "h4",
                variant: "h3",
                className: "text-neutral-900 ",
                children: [
                    "Join an ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-primary-500",
                        children: "exclusive"
                    }),
                    " group of park explorers!"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/utilities/guidelines",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* IconButton */.h, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {}),
                    className: "w-full flex justify-center md:w-fit md:h-[48px]",
                    children: "Read our guidelines"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/Partners/OurPartnersSection/OurPartnersSection.tsx + 3 modules
var OurPartnersSection = __webpack_require__(921);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/Pages/AboutUsPage/AboutUsPage.tsx










const AboutUsPage = ()=>{
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUsCover, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
                        className: "!py-[48px] lg:!py-[80px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionSection, {
                                title: "Our mission",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-[50px] h-[50px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                                        src: "/media/illustrations/tv-parks-channel.webp",
                                        alt: "Grand canyon",
                                        fill: true,
                                        className: "object-contain"
                                    })
                                }),
                                bgcImg: "/media/obamabridge.webp",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSectionParagraph, {
                                        className: "md:mb-4 lg:mb-2",
                                        children: "We all long to connect to something bigger than ourselves. Parks give us that. Natural spaces broaden our horizons and remind us of our place in the universe. Historic spaces bond us to our shared heritage and deepen our understanding of where we’ve come from."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSectionParagraph, {
                                        children: "At Parks Channel, our mission is to become a destination platform for “America’s Best Idea” – at home, on the journey and for making memories. We want to make it easier to discover amazing places and then actually go there. We want to tell stories that entertain and inform. We want to build a community of content creators who inspire others through their journeys."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
                        className: "!py-[48px] lg:!py-[80px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DescriptionSection, {
                                title: "One more, very important thing",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-[50px] h-[50px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                                        src: "/media/illustrations/earth.webp",
                                        alt: "Grand canyon",
                                        fill: true,
                                        className: "object-contain"
                                    })
                                }),
                                bgcImg: "/media/grand-canyon.jpg",
                                reverse: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSectionParagraph, {
                                        children: "The Parks Channel is deeply committed to the mission of protecting and enhancing the park experience."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSectionParagraph, {
                                        children: "Our content will cover critical issues facing our parks, including efforts to reach younger and more diverse demographics, mitigate the challenges of climate change and address the problem of overcrowding, as well as campaigns to protect more of our natural and historic spaces."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSectionParagraph, {
                                        children: "The Parks Channel will set aside a portion of profits to support science, conservation and heritage projects, working with non-profit groups to help achieve their goals."
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
                className: "!py-[56px] lg:!py-[96px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhoWeAreSection, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTASection/* CTASection */.t, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurPartnersSection/* OurPartnersSection */.o, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white mb-2 md:mb-4 lg:mb-[102px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
                    className: "!py-[80px] lg:!py-[88px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidePageWrapper/* InsidePageWrapper */.n, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinGroupBanner, {})
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/about-us.tsx

var __N_SSP = true;
/* harmony default export */ var about_us = (AboutUsPage);


/***/ }),

/***/ 76356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useButtonsAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24900);


const useButtonsAnalytics = ()=>{
    const { onButtonClick  } = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    const listenEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (!e || !e.target) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onButtonClick(e.target.textContent);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!document) return;
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button)=>button.addEventListener("click", listenEvent));
        return ()=>{
            buttons.forEach((button)=>button.removeEventListener("click", listenEvent));
        };
    }, []);
};


/***/ }),

/***/ 36221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ CardAvatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const CardAvatar = (param)=>{
    let { children , size ="2xl" , backgroundClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-neutral-100 rounded-full w-fit h-fit backdrop-blur-md group", backgroundWidth(size), backgroundClassName),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative overflow-hidden rounded-full",
            children: children
        })
    });
};
function backgroundWidth(size) {
    switch(size){
        case "xs":
            return "p-1";
        case "sm":
            return "p-1";
        case "md":
            return "p-1";
        case "lg":
            return "p-2";
        case "xl":
            return "p-2";
        case "2xl":
            return "p-3";
        default:
            return "p-5";
    }
}


/***/ }),

/***/ 74718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BannerWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const BannerWrapper = (param)=>{
    let { children , icon , className , variant ="auto"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-6 flex items-center gap-6 rounded-2xl", {
            "flex-col md:flex-row": variant === "auto",
            "flex-col": variant === "vertical"
        }, className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-w-full flex justify-center md:min-w-[25%] xl:min-w-[200px]",
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex flex-col items-center text-center gap-6", {
                    "md:items-start md:text-left": variant === "auto"
                }),
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 7346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react_alice_carousel_lib_alice_carousel_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52833);
/* harmony import */ var react_alice_carousel_lib_alice_carousel_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_alice_carousel_lib_alice_carousel_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var react_alice_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24644);
/* harmony import */ var react_alice_carousel__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_alice_carousel__WEBPACK_IMPORTED_MODULE_3__);




const Carousel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((param, ref)=>{
    let { items , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_alice_carousel__WEBPACK_IMPORTED_MODULE_3___default()), {
        ref: ref,
        mouseTracking: true,
        items: items,
        controlsStrategy: "alternate",
        keyboardNavigation: true,
        disableButtonsControls: true,
        infinite: true,
        ...rest
    });
});


/***/ }),

/***/ 14927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ItemsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function ItemsList(param) {
    let { items , renderItem , className , liClassName , noItemsMessage ="Not found" , noItemsClassName  } = param;
    if (items.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-medium text-sm text-neutral-900 my-5 text-center block", noItemsClassName),
            children: noItemsMessage
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className),
        children: items.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", liClassName),
                children: renderItem(item)
            }, item.id))
    });
}


/***/ }),

/***/ 88044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(49236);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/dialog/dialog.js + 10 modules
var dialog = __webpack_require__(81231);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(54109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui/src/components/CloseButton/CloseButton.tsx




const CloseButton = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { onClick , className  } = param;
    return (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classnames_default()("flex items-center justify-center h-10 w-10 rounded-full focus:outline-none", className),
        onClick: onClick,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
            className: "h-5 w-5",
            "aria-hidden": "true"
        })
    });
});

;// CONCATENATED MODULE: ../ui/src/components/Modal/Modal.tsx





const Modal = (param)=>{
    let { children , isOpen , setIsOpen , testId , title , contentClassName , closeOnOutside =true , exitButton  } = param;
    const cancelButtonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: isOpen,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-[100]",
            initialFocus: cancelButtonRef,
            onClose: ()=>closeOnOutside ? setIsOpen(false) : null,
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-90 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed z-10 inset-0 overflow-y-auto lg:p-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center min-h-full text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: classnames_default()("relative bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all  sm:p-6 flex flex-col w-full lg:rounded-2xl ", contentClassName),
                                children: [
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("pb-4"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "font-bold text-lg text-neutral-700 mt-1",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-4 right-4 z-50",
                                        children: exitButton ? exitButton(()=>setIsOpen(false), cancelButtonRef) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                            onClick: ()=>setIsOpen(false),
                                            ref: cancelButtonRef
                                        })
                                    }),
                                    children
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 90202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59785);




const Tag = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)((param)=>{
    let { id , value , size ="sm" , color ="transparent" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
        variant: "bodySmall",
        id: id,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("normal-case rounded-full text-neutral-700 inline-block font-medium whitespace-nowrap", tagSize(size), tagColor(color), className),
        children: typeof value === "string" ? capitalizeFirstLetter(value) : value
    });
});
function tagSize(size) {
    switch(size){
        case "sm":
            return "py-1 px-2";
        default:
            return "py-2 px-4";
    }
}
function tagColor(color) {
    switch(color){
        case "orange":
            return "bg-orange1";
        case "yellow":
            return "bg-yellow1";
        case "transparent":
            return "bg-transparent";
        case "gray":
            return "bg-neutral-100";
        case "darkGray":
            return "bg-neutral-200";
        case "light":
            return "bg-white";
        default:
            return "bg-".concat(color);
    }
}
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ InsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const InsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className , id  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-6 w-full max-w-6xl mx-auto", className),
        id: id,
        children: children
    });
};


/***/ }),

/***/ 55368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OutsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 w-full max-w-screen-2xl mx-auto md:p-[30px] lg:p-10", className),
        children: children
    });
};


/***/ }),

/***/ 71740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ArrowRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        className: className,
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17 8L21 12M21 12L17 16M21 12H3",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ChevronLeft = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.5182 11.9998L15.6582 17.2468C16.0743 17.6108 16.1163 18.2428 15.7522 18.6578C15.3882 19.0738 14.7563 19.1158 14.3413 18.7528L8.34125 12.7518C7.88625 12.3538 7.88625 11.6458 8.34125 11.2478L14.3413 5.24782C14.7563 4.88382 15.3882 4.92582 15.7522 5.34082C16.1163 5.75682 16.0743 6.38882 15.6582 6.75182L10.5182 11.9998Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_712_11636",
                    x1: "8",
                    y1: "6.68962",
                    x2: "16.8537",
                    y2: "7.59025",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#2CBC32"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.98762",
                            stopColor: "#07996E"
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 98427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ChevronRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ChevronRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9 5L16 12L9 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 81231:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ mt; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/match.js
var match = __webpack_require__(47526);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/render.js
var render = __webpack_require__(48159);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-sync-refs.js
var use_sync_refs = __webpack_require__(46104);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/keyboard.js
var keyboard = __webpack_require__(68578);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/bugs.js
var bugs = __webpack_require__(41582);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-id.js
var use_id = __webpack_require__(22094);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.js
var use_server_handoff_complete = __webpack_require__(48676);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/internal/hidden.js
let a="div";var hidden_s=(e=>(e[e.None=1]="None",e[e.Focusable=2]="Focusable",e[e.Hidden=4]="Hidden",e))(hidden_s||{});let h=(0,render/* forwardRefWithAs */.yV)(function(t,o){let{features:e=1,...r}=t,d={ref:o,"aria-hidden":(e&2)===2?!0:void 0,style:{position:"absolute",width:1,height:1,padding:0,margin:-1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap",borderWidth:"0",...(e&4)===4&&(e&2)!==2&&{display:"none"}}};return (0,render/* render */.sY)({ourProps:d,theirProps:r,slot:{},defaultTag:a,name:"Hidden"})});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/focus-management.js
var focus_management = __webpack_require__(69134);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-event.js
var use_event = __webpack_require__(89646);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-window-event.js
var use_window_event = __webpack_require__(77823);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-tab-direction.js
var use_tab_direction_s=(r=>(r[r.Forwards=0]="Forwards",r[r.Backwards=1]="Backwards",r))(use_tab_direction_s||{});function use_tab_direction_n(){let e=(0,react.useRef)(0);return (0,use_window_event/* useWindowEvent */.s)("keydown",o=>{o.key==="Tab"&&(e.current=o.shiftKey?1:0)},!0),e}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-is-mounted.js
var use_is_mounted = __webpack_require__(91402);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-owner.js
var use_owner = __webpack_require__(25264);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-latest-value.js
var use_latest_value = __webpack_require__(31606);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-event-listener.js
function E(n,e,a,t){let i=(0,use_latest_value/* useLatestValue */.E)(a);(0,react.useEffect)(()=>{n=n!=null?n:window;function r(o){i.current(o)}return n.addEventListener(e,r,t),()=>n.removeEventListener(e,r,t)},[n,e,t])}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/micro-task.js
var micro_task = __webpack_require__(79999);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-watch.js
function m(o,t){let r=(0,react.useRef)([]),e=(0,use_event/* useEvent */.z)(o);(0,react.useEffect)(()=>{for(let[u,f]of t.entries())if(r.current[u]!==f){let i=e(t);return r.current=t,i}},[e,...t])}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/focus-trap/focus-trap.js
let N="div";var F=(r=>(r[r.None=1]="None",r[r.InitialFocus=2]="InitialFocus",r[r.TabLock=4]="TabLock",r[r.FocusLock=8]="FocusLock",r[r.RestoreFocus=16]="RestoreFocus",r[r.All=30]="All",r))(F||{});let fe=Object.assign((0,render/* forwardRefWithAs */.yV)(function(n,e){let l=(0,react.useRef)(null),u=(0,use_sync_refs/* useSyncRefs */.T)(l,e),{initialFocus:f,containers:r,features:o=30,...c}=n;(0,use_server_handoff_complete/* useServerHandoffComplete */.H)()||(o=1);let s=(0,use_owner/* useOwnerDocument */.i)(l);V({ownerDocument:s},Boolean(o&16));let O=x({ownerDocument:s,container:l,initialFocus:f},Boolean(o&2));G({ownerDocument:s,container:l,containers:r,previousActiveElement:O},Boolean(o&8));let v=use_tab_direction_n(),p=(0,use_event/* useEvent */.z)(()=>{let T=l.current;!T||(0,match/* match */.E)(v.current,{[use_tab_direction_s.Forwards]:()=>(0,focus_management/* focusIn */.jA)(T,focus_management/* Focus.First */.TO.First),[use_tab_direction_s.Backwards]:()=>(0,focus_management/* focusIn */.jA)(T,focus_management/* Focus.Last */.TO.Last)})}),j={ref:u};return react.createElement(react.Fragment,null,Boolean(o&4)&&react.createElement(h,{as:"button",type:"button",onFocus:p,features:hidden_s.Focusable}),(0,render/* render */.sY)({ourProps:j,theirProps:c,defaultTag:N,name:"FocusTrap"}),Boolean(o&4)&&react.createElement(h,{as:"button",type:"button",onFocus:p,features:hidden_s.Focusable}))}),{features:F});function V({ownerDocument:t},n){let e=(0,react.useRef)(null);E(t==null?void 0:t.defaultView,"focusout",u=>{!n||e.current||(e.current=u.target)},!0),m(()=>{n||((t==null?void 0:t.activeElement)===(t==null?void 0:t.body)&&(0,focus_management/* focusElement */.C5)(e.current),e.current=null)},[n]);let l=(0,react.useRef)(!1);(0,react.useEffect)(()=>(l.current=!1,()=>{l.current=!0,(0,micro_task/* microTask */.Y)(()=>{!l.current||((0,focus_management/* focusElement */.C5)(e.current),e.current=null)})}),[])}function x({ownerDocument:t,container:n,initialFocus:e},l){let u=(0,react.useRef)(null);return m(()=>{if(!l)return;let f=n.current;if(!f)return;let r=t==null?void 0:t.activeElement;if(e!=null&&e.current){if((e==null?void 0:e.current)===r){u.current=r;return}}else if(f.contains(r)){u.current=r;return}e!=null&&e.current?(0,focus_management/* focusElement */.C5)(e.current):(0,focus_management/* focusIn */.jA)(f,focus_management/* Focus.First */.TO.First)===focus_management/* FocusResult.Error */.fE.Error&&console.warn("There are no focusable elements inside the <FocusTrap />"),u.current=t==null?void 0:t.activeElement},[l]),u}function G({ownerDocument:t,container:n,containers:e,previousActiveElement:l},u){let f=(0,use_is_mounted/* useIsMounted */.t)();E(t==null?void 0:t.defaultView,"focus",r=>{if(!u||!f.current)return;let o=new Set(e==null?void 0:e.current);o.add(n);let c=l.current;if(!c)return;let s=r.target;s&&s instanceof HTMLElement?W(o,s)?(l.current=s,(0,focus_management/* focusElement */.C5)(s)):(r.preventDefault(),r.stopPropagation(),(0,focus_management/* focusElement */.C5)(c)):(0,focus_management/* focusElement */.C5)(l.current)},!0)}function W(t,n){var e;for(let l of t)if((e=l.current)!=null&&e.contains(n))return!0;return!1}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/utils/owner.js
var owner = __webpack_require__(33530);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.js
var use_iso_morphic_effect = __webpack_require__(67312);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-inert-others.js
let i=new Set,r=new Map;function u(t){t.setAttribute("aria-hidden","true"),t.inert=!0}function l(t){let n=r.get(t);!n||(n["aria-hidden"]===null?t.removeAttribute("aria-hidden"):t.setAttribute("aria-hidden",n["aria-hidden"]),t.inert=n.inert)}function M(t,n=!0){(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(!n||!t.current)return;let o=t.current,a=(0,owner/* getOwnerDocument */.r)(o);if(!!a){i.add(o);for(let e of r.keys())e.contains(o)&&(l(e),r.delete(e));return a.querySelectorAll("body > *").forEach(e=>{if(e instanceof HTMLElement){for(let f of i)if(e.contains(f))return;i.size===1&&(r.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),u(e))}}),()=>{if(i.delete(o),i.size>0)a.querySelectorAll("body > *").forEach(e=>{if(e instanceof HTMLElement&&!r.has(e)){for(let f of i)if(e.contains(f))return;r.set(e,{"aria-hidden":e.getAttribute("aria-hidden"),inert:e.inert}),u(e)}});else for(let e of r.keys())l(e),r.delete(e)}}},[n])}

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(63730);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/internal/portal-force-root.js
let e=(0,react.createContext)(!1);function portal_force_root_l(){return (0,react.useContext)(e)}function portal_force_root_P(o){return react.createElement(e.Provider,{value:o.force},o.children)}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/portal/portal.js
function H(i){let u=portal_force_root_l(),o=(0,react.useContext)(portal_E),e=(0,use_owner/* useOwnerDocument */.i)(i),[r,f]=(0,react.useState)(()=>{if(!u&&o!==null||typeof window=="undefined")return null;let n=e==null?void 0:e.getElementById("headlessui-portal-root");if(n)return n;if(e===null)return null;let t=e.createElement("div");return t.setAttribute("id","headlessui-portal-root"),e.body.appendChild(t)});return (0,react.useEffect)(()=>{r!==null&&(e!=null&&e.body.contains(r)||e==null||e.body.appendChild(r))},[r,e]),(0,react.useEffect)(()=>{u||o!==null&&f(o.current)},[o,f,u]),r}let portal_x=react.Fragment,_=(0,render/* forwardRefWithAs */.yV)(function(u,o){let e=u,r=(0,react.useRef)(null),f=(0,use_sync_refs/* useSyncRefs */.T)((0,use_sync_refs/* optionalRef */.h)(a=>{r.current=a}),o),n=(0,use_owner/* useOwnerDocument */.i)(r),t=H(r),[l]=(0,react.useState)(()=>{var a;return typeof window=="undefined"?null:(a=n==null?void 0:n.createElement("div"))!=null?a:null}),A=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)(),p=(0,react.useRef)(!1);return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>{if(p.current=!1,!(!t||!l))return t.contains(l)||(l.setAttribute("data-headlessui-portal",""),t.appendChild(l)),()=>{p.current=!0,(0,micro_task/* microTask */.Y)(()=>{var a;!p.current||!t||!l||(t.removeChild(l),t.childNodes.length<=0&&((a=t.parentElement)==null||a.removeChild(t)))})}},[t,l]),A?!t||!l?null:(0,react_dom.createPortal)((0,render/* render */.sY)({ourProps:{ref:f},theirProps:e,defaultTag:portal_x,name:"Portal"}),l):null}),U=react.Fragment,portal_E=(0,react.createContext)(null),j=(0,render/* forwardRefWithAs */.yV)(function(u,o){let{target:e,...r}=u,n={ref:(0,use_sync_refs/* useSyncRefs */.T)(o)};return react.createElement(portal_E.Provider,{value:e},(0,render/* render */.sY)({ourProps:n,theirProps:r,defaultTag:U,name:"Popover.Group"}))}),portal_X=Object.assign(_,{Group:j});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/description/description.js
let d=(0,react.createContext)(null);function description_u(){let r=(0,react.useContext)(d);if(r===null){let t=new Error("You used a <Description /> component, but it is not inside a relevant parent.");throw Error.captureStackTrace&&Error.captureStackTrace(t,description_u),t}return r}function k(){let[r,t]=(0,react.useState)([]);return[r.length>0?r.join(" "):void 0,(0,react.useMemo)(()=>function(e){let i=(0,use_event/* useEvent */.z)(n=>(t(o=>[...o,n]),()=>t(o=>{let c=o.slice(),p=c.indexOf(n);return p!==-1&&c.splice(p,1),c}))),s=(0,react.useMemo)(()=>({register:i,slot:e.slot,name:e.name,props:e.props}),[i,e.slot,e.name,e.props]);return react.createElement(d.Provider,{value:s},e.children)},[t])]}let S="p",description_F=(0,render/* forwardRefWithAs */.yV)(function(t,a){let e=description_u(),i=`headlessui-description-${(0,use_id/* useId */.M)()}`,s=(0,use_sync_refs/* useSyncRefs */.T)(a);(0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>e.register(i),[i,e.register]);let n=t,o={ref:s,...e.props,id:i};return (0,render/* render */.sY)({ourProps:o,theirProps:n,slot:e.slot||{},defaultTag:S,name:e.name||"Description"})});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/internal/open-closed.js
var open_closed = __webpack_require__(92945);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/internal/stack-context.js
let o=(0,react.createContext)(()=>{});o.displayName="StackContext";var stack_context_f=(e=>(e[e.Add=0]="Add",e[e.Remove=1]="Remove",e))(stack_context_f||{});function stack_context_x(){return (0,react.useContext)(o)}function C({children:u,onUpdate:r,type:e,element:n}){let c=stack_context_x(),t=(0,use_event/* useEvent */.z)((...a)=>{r==null||r(...a),c(...a)});return (0,use_iso_morphic_effect/* useIsoMorphicEffect */.e)(()=>(t(0,e,n),()=>t(1,e,n)),[t,e,n]),react.createElement(o.Provider,{value:t},u)}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/hooks/use-outside-click.js
var use_outside_click = __webpack_require__(59816);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@headlessui+react@1.6.6_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/dialog/dialog.js
var be=(t=>(t[t.Open=0]="Open",t[t.Closed=1]="Closed",t))(be||{}),Ce=(e=>(e[e.SetTitleId=0]="SetTitleId",e))(Ce||{});let Oe={[0](i,e){return i.titleId===e.id?i:{...i,titleId:e.id}}},dialog_M=(0,react.createContext)(null);dialog_M.displayName="DialogContext";function L(i){let e=(0,react.useContext)(dialog_M);if(e===null){let t=new Error(`<${i} /> is missing a parent <Dialog /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(t,L),t}return e}function Se(i,e){return (0,match/* match */.E)(e.type,Oe,i,e)}let Le="div",we=render/* Features.RenderStrategy */.AN.RenderStrategy|render/* Features.Static */.AN.Static,Fe=(0,render/* forwardRefWithAs */.yV)(function(e,t){let{open:o,onClose:n,initialFocus:d,__demoMode:g=!1,...c}=e,[m,D]=(0,react.useState)(0),v=(0,open_closed/* useOpenClosed */.oJ)();o===void 0&&v!==null&&(o=(0,match/* match */.E)(v,{[open_closed/* State.Open */.ZM.Open]:!0,[open_closed/* State.Closed */.ZM.Closed]:!1}));let a=(0,react.useRef)(new Set),f=(0,react.useRef)(null),J=(0,use_sync_refs/* useSyncRefs */.T)(f,t),W=(0,react.useRef)(null),P=(0,use_owner/* useOwnerDocument */.i)(f),B=e.hasOwnProperty("open")||v!==null,G=e.hasOwnProperty("onClose");if(!B&&!G)throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");if(!B)throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");if(!G)throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");if(typeof o!="boolean")throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);if(typeof n!="function")throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${n}`);let s=o?0:1,[y,Q]=(0,react.useReducer)(Se,{titleId:null,descriptionId:null,panelRef:(0,react.createRef)()}),R=(0,use_event/* useEvent */.z)(()=>n(!1)),U=(0,use_event/* useEvent */.z)(r=>Q({type:0,id:r})),_=(0,use_server_handoff_complete/* useServerHandoffComplete */.H)()?g?!1:s===0:!1,w=m>1,$=(0,react.useContext)(dialog_M)!==null,X=w?"parent":"leaf";M(f,w?_:!1),(0,use_outside_click/* useOutsideClick */.O)(()=>{var l,p;return[...Array.from((l=P==null?void 0:P.querySelectorAll("body > *, [data-headlessui-portal]"))!=null?l:[]).filter(T=>!(!(T instanceof HTMLElement)||T.contains(W.current)||y.panelRef.current&&T.contains(y.panelRef.current))),(p=y.panelRef.current)!=null?p:f.current]},R,_&&!w),E(P==null?void 0:P.defaultView,"keydown",r=>{r.defaultPrevented||r.key===keyboard/* Keys.Escape */.R.Escape&&s===0&&(w||(r.preventDefault(),r.stopPropagation(),R()))}),(0,react.useEffect)(()=>{var j;if(s!==0||$)return;let r=(0,owner/* getOwnerDocument */.r)(f);if(!r)return;let l=r.documentElement,p=(j=r.defaultView)!=null?j:window,T=l.style.overflow,le=l.style.paddingRight,Y=p.innerWidth-l.clientWidth;if(l.style.overflow="hidden",Y>0){let ne=l.clientWidth-l.offsetWidth,ie=Y-ne;l.style.paddingRight=`${ie}px`}return()=>{l.style.overflow=T,l.style.paddingRight=le}},[s,$]),(0,react.useEffect)(()=>{if(s!==0||!f.current)return;let r=new IntersectionObserver(l=>{for(let p of l)p.boundingClientRect.x===0&&p.boundingClientRect.y===0&&p.boundingClientRect.width===0&&p.boundingClientRect.height===0&&R()});return r.observe(f.current),()=>r.disconnect()},[s,f,R]);let[Z,ee]=k(),te=`headlessui-dialog-${(0,use_id/* useId */.M)()}`,oe=(0,react.useMemo)(()=>[{dialogState:s,close:R,setTitleId:U},y],[s,y,R,U]),N=(0,react.useMemo)(()=>({open:s===0}),[s]),re={ref:J,id:te,role:"dialog","aria-modal":s===0?!0:void 0,"aria-labelledby":y.titleId,"aria-describedby":Z};return react.createElement(C,{type:"Dialog",element:f,onUpdate:(0,use_event/* useEvent */.z)((r,l,p)=>{l==="Dialog"&&(0,match/* match */.E)(r,{[stack_context_f.Add](){a.current.add(p),D(T=>T+1)},[stack_context_f.Remove](){a.current.add(p),D(T=>T-1)}})})},react.createElement(portal_force_root_P,{force:!0},react.createElement(portal_X,null,react.createElement(dialog_M.Provider,{value:oe},react.createElement(portal_X.Group,{target:f},react.createElement(portal_force_root_P,{force:!1},react.createElement(ee,{slot:N,name:"Dialog.Description"},react.createElement(fe,{initialFocus:d,containers:a,features:_?(0,match/* match */.E)(X,{parent:fe.features.RestoreFocus,leaf:fe.features.All&~fe.features.FocusLock}):fe.features.None},(0,render/* render */.sY)({ourProps:re,theirProps:c,slot:N,defaultTag:Le,features:we,visible:s===0,name:"Dialog"})))))))),react.createElement(h,{features:hidden_s.Hidden,ref:W}))}),ke="div",Me=(0,render/* forwardRefWithAs */.yV)(function(e,t){let[{dialogState:o,close:n}]=L("Dialog.Overlay"),d=(0,use_sync_refs/* useSyncRefs */.T)(t),g=`headlessui-dialog-overlay-${(0,use_id/* useId */.M)()}`,c=(0,use_event/* useEvent */.z)(a=>{if(a.target===a.currentTarget){if((0,bugs/* isDisabledReactIssue7711 */.P)(a.currentTarget))return a.preventDefault();a.preventDefault(),a.stopPropagation(),n()}}),m=(0,react.useMemo)(()=>({open:o===0}),[o]);return (0,render/* render */.sY)({ourProps:{ref:d,id:g,"aria-hidden":!0,onClick:c},theirProps:e,slot:m,defaultTag:ke,name:"Dialog.Overlay"})}),_e="div",Ie=(0,render/* forwardRefWithAs */.yV)(function(e,t){let[{dialogState:o},n]=L("Dialog.Backdrop"),d=(0,use_sync_refs/* useSyncRefs */.T)(t),g=`headlessui-dialog-backdrop-${(0,use_id/* useId */.M)()}`;(0,react.useEffect)(()=>{if(n.panelRef.current===null)throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.")},[n.panelRef]);let c=(0,react.useMemo)(()=>({open:o===0}),[o]);return react.createElement(portal_force_root_P,{force:!0},react.createElement(portal_X,null,(0,render/* render */.sY)({ourProps:{ref:d,id:g,"aria-hidden":!0},theirProps:e,slot:c,defaultTag:_e,name:"Dialog.Backdrop"})))}),xe="div",He=(0,render/* forwardRefWithAs */.yV)(function(e,t){let[{dialogState:o},n]=L("Dialog.Panel"),d=(0,use_sync_refs/* useSyncRefs */.T)(t,n.panelRef),g=`headlessui-dialog-panel-${(0,use_id/* useId */.M)()}`,c=(0,react.useMemo)(()=>({open:o===0}),[o]),m=(0,use_event/* useEvent */.z)(a=>{a.stopPropagation()});return (0,render/* render */.sY)({ourProps:{ref:d,id:g,onClick:m},theirProps:e,slot:c,defaultTag:xe,name:"Dialog.Panel"})}),We="h2",Be=(0,render/* forwardRefWithAs */.yV)(function(e,t){let[{dialogState:o,setTitleId:n}]=L("Dialog.Title"),d=`headlessui-dialog-title-${(0,use_id/* useId */.M)()}`,g=(0,use_sync_refs/* useSyncRefs */.T)(t);(0,react.useEffect)(()=>(n(d),()=>n(null)),[d,n]);let c=(0,react.useMemo)(()=>({open:o===0}),[o]);return (0,render/* render */.sY)({ourProps:{ref:g,id:d},theirProps:e,slot:c,defaultTag:We,name:"Dialog.Title"})}),mt=Object.assign(Fe,{Backdrop:Ie,Panel:He,Overlay:Me,Title:Be,Description:description_F});


/***/ }),

/***/ 54109:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);


function XIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(XIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [916,9774,2888,179], function() { return __webpack_exec__(13096); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);